<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c04"><a id="page04"></a>Keeping the Fizz in the Marriage</h1>
<p class="nonindent">Amanda Blake of Northampton, Massachusetts, who had been a loyal employee of the Coca-Cola Bottling Company for eight years, was discovered to be a traitor. Coca-Cola found out that Blake had fallen in love with and become engaged to David Cronin, who worked for archrival Pepsi. Coke demanded that Blake either break off her engagement, persuade Cronin to leave Pepsi, or resign from her position at Coca-Cola. Blake nearly popped her top when she was given these options and decided not to do anything of the sort. Coca-Cola promptly fired her for “conflict of interest.” But Blake spun the bottle on Coca-Cola and sued for damages, winning a $600,000 settlement. Now that’s the real thing!<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c04_r1.vue?4565e9e4